"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
let AbstractAnalysisComponent = class AbstractAnalysisComponent {
    constructor() {
        this.data = null;
        this.tableData = null;
        this.filteredTableData = null;
        this.tableColumns = [];
        this.labels = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
        this.colorPalette = ['#d9bc6c', '#a3c174', '#69c191', '#23bbb4', '#00b1cf', '#52a1d8'];
        this.chartData = { labels: this.labels, datasets: [] };
        this.chartType = 'line';
        this.chartReady = false;
        this.chartSubtitle = '';
        this.counts = {
            dataFiltered: 0,
            dataTotal: 0,
            tableFiltered: 0,
            tableTotal: 0,
        };
        /** Here we prepare data to be shown in a chart.
         * The X-axis will always be constructed from 12 months.
         *
         * `filter` defines a selectable attribute, on which we group datasets.
         * For example we show a line for each seller, make, model etc.
         *
         * `mode` defines, how we group the collected values.
        */
        this.filterData = (rerender) => {
            if (!this.data)
                return;
            this.chartReady = false;
            this.chartData = { datasets: [], labels: this.labels };
            // this.counts.dataTotal = this.data.length;
            this.counts.dataFiltered = 0;
            this.chartData.datasets = [];
            // One ChartType is used for grouping the data
            let groups = [...new Set(this.data.map((d) => d[this.filter.filterGroup]))];
            if (this.filter.filterValues[this.filter.filterGroup].length) {
                groups = this.filter.filterValues[this.filter.filterGroup];
                this.chartSubtitle = `Vergleich von ${this.filter.filterTranslations[this.filter.filterGroup]} im Jahr ${this.filter.yearValue}`;
            }
            else {
                groups = [null];
                this.chartSubtitle = `Zeige alle ${this.filter.filterTranslations[this.filter.filterGroup]} im Jahr ${this.filter.yearValue}`;
            }
            const dateFiltered = this.data.filter((d) => String((0, moment_1.default)(d.date).year()) === this.filter.yearValue);
            this.counts.dataTotal = dateFiltered.length;
            for (const [groupIndex, group] of groups.entries()) {
                const dataset = {
                    data: Array(this.labels.length).fill(0),
                    label: group || `Alle ${this.filter.filterTranslations[this.filter.filterGroup]}`,
                    cubicInterpolationMode: 'monotone',
                    borderColor: this.colorPalette[groupIndex % this.colorPalette.length],
                    tension: 0,
                };
                // Group by month
                for (const [i, month] of this.labels.entries()) {
                    let filtered = dateFiltered
                        .filter((d) => {
                        if (!group)
                            return true;
                        return d[this.filter.filterGroup] === group;
                    })
                        .filter((d) => (0, moment_1.default)(d.date).month() === i);
                    for (const [index, filter] of Object.entries(this.filter.filterValues)) {
                        if (filter && filter.length) {
                            filtered = filtered.filter((f) => filter.includes(f[index]));
                        }
                    }
                    this.counts.dataFiltered += filtered.length;
                    switch (this.mode) {
                        default:
                            dataset.data[i] = filtered.length;
                            break;
                    }
                }
                this.chartData.datasets.push(dataset);
            }
            /** The chart only redraws, if we use this hack. But we can't use it for the first draw. */
            if (rerender) {
                setTimeout(() => {
                    this.chartReady = true;
                });
            }
            else {
                this.chartReady = true;
            }
        };
        this.filterTable = () => {
            if (!this.tableData)
                return;
            let filteredData = this.tableData
                .filter((d) => (0, moment_1.default)(d.date).format('YYYY') === this.filter.yearValue);
            // We show total count depending on selected date
            this.counts.tableTotal = filteredData.length;
            for (const [index, filter] of Object.entries(this.filter.filterValues)) {
                if (filter && filter.length) {
                    filteredData = filteredData.filter((f) => filter.includes(f[index]));
                }
            }
            this.counts.tableFiltered = filteredData.length;
            this.filteredTableData = filteredData
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        };
        this.refresh = () => {
            this.filterData(true);
            this.filterTable();
        };
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const { chart, table } = yield this.getData();
            this.data = chart;
            this.tableData = table;
            this.tableColumns = Object.keys(this.tableData[0]);
            for (const filterOption of Object.keys(this.filter.filterOptions)) {
                this.filter.filterOptions[filterOption] = [...new Set(this.data.map((d) => d[filterOption]))];
            }
            if (this.data.length) {
                this.filter.yearOptions = [...new Set(this.data.map((d) => (0, moment_1.default)(d.date).format('YYYY')))];
            }
            else {
                this.filter.yearOptions = [...new Set(this.tableData.map((d) => (0, moment_1.default)(d.date).format('YYYY')))];
            }
            this.filterData();
            this.filterTable();
        });
    }
};
AbstractAnalysisComponent = __decorate([
    (0, core_1.Component)({
        selector: 'abstract-analysis',
        template: '',
    })
], AbstractAnalysisComponent);
exports.default = AbstractAnalysisComponent;
